<template>
  <div :style="!popupParam.isPop ? 'width: 1000px; max-width: 1000px !important' : ''">
    <c-table
      ref="table"
      title="시설 목록"
      tableId="facility"
      :columns="grid.columns"
      :data="grid.data"
      :gridHeight="grid.height"
      :columnSetting="false"
      @linkClick="linkClick"
    >
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'process-facility',
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
          processCd: '',
          isPop: false,
        }
      },
    },
    props: {
      type: Object,
      default: function() {
        return {
          row: [],
        }
      },
    },
    col: {
      type: Object,
      default: function() {
        return {}
      },
    },
  },
  data() {
    return {
      searchParam: {
        processCd: null,
        useFlag: 'Y',
      },
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'facilityName',
            field: 'facilityName',
            label: '시설명(차량번호)',
            align: 'left',
            style: 'width:250px',
            type: 'link',
            sortable: false,
          },
          {
            name: 'facilityNo',
            field: 'facilityNo',
            label: '시설관리번호',
            align: 'center',
            style: 'width:80px',
            sortable: false,
          },
          {
            name: 'processCd',
            field: 'processCd',
            label: '공정/보관대장/차량',
            align: 'center',
            style: 'width:150px',
            sortable: false,
          },
          {
            name: 'hcfFacilityTypeName',
            field: 'hcfFacilityTypeName',
            label: '시설유형',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'selfCheck',
            field: 'hcfInspectionCycleName',
            label: '자체점검',
            child: [
              {
                name: 'lastSelfCheckDate',
                field: 'lastSelfCheckDate',
                label: '최종자체점검일',
                align: 'center',
                style: 'width:90px',
                sortable: false,
              },
              {
                name: 'nextSelfCheckDate',
                field: 'nextSelfCheckDate',
                label: '차기자체점검일',
                align: 'center',
                style: 'width:90px',
                sortable: false,
              },
            ]
          },
        ],
        data: [],
        height: '500px'
      },
      popupOptions: {
        isFull: false,
        width: '100%',
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      editable: true,
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.env.facility.list.url
      // code setting
      // list setting
      if (!this.popupParam.isPop) {
        this.$set(this.searchParam, 'processCd', this.props.row.processCd)
      } else {
        this.$set(this.searchParam, 'processCd', this.popupParam.processCd)
      }
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    /* eslint-disable no-unused-vars */
    addFacility() {
      this.linkClick();
    },
    linkClick(row, col, index) {
      this.popupOptions.title = '시설 상세'; // 시설 상세
      this.popupOptions.param = {
        facilityCd: row ? row.facilityCd : '',
      };
      this.popupOptions.target = () => import(`${'./hazardFacilityDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
